import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button, Notification } from 'base-ui'

import { useOpenableControls } from '../../../generic-hooks'
import { IconSendMail } from '../../../icons'
import { ProductPrescriptionDialog } from '../../../product'
import { productAccessorIsPrescriptionProduct } from '../../model/productAccessor/productAccessorIsPrescriptionProduct'
import { useProductPageContext } from '../productPageContext'

export const ProductPrescriptionNotificationRequired: FC = () => {
  const { currentVariant } = useProductPageContext()
  const isPrescriptionProduct =
    productAccessorIsPrescriptionProduct(currentVariant)
  const modalControls = useOpenableControls()

  if (!isPrescriptionProduct) {
    return null
  }

  return (
    <div className="flex flex-col gap-2.5">
      <Notification icon={<IconSendMail />} severity="warning">
        <FormattedMessage id="productAdditonalInfos.prescription.infobox.content" />
      </Notification>
      <Button
        className="font-normal"
        onClick={modalControls.handleOpen}
        variant="outlined"
      >
        <FormattedMessage id="productAdditonalInfos.prescription.infobox.links" />
      </Button>
      {modalControls.isOpen ? (
        <ProductPrescriptionDialog
          isOpen={modalControls.isOpen}
          onClose={modalControls.handleClose}
        />
      ) : null}
    </div>
  )
}
